export default "__VITE_ASSET__DzDFaQde__"